<template>
  <div>
    <PageLoader v-bind:storage="appLoading" />
    <ServerError v-if="ServerError" />
    <v-layout wrap justify-center>
      <v-flex xs8>
        <v-img :src="mediaURL + pageData.topImage" height="250" cover>
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-progress-circular
                indeterminate
                color="#FF2323"
              ></v-progress-circular>
            </v-row>
          </template>
        </v-img>
      </v-flex>
     <v-flex text-left xs12 sm8 pt-4 >
        <span style="font-size:20px;font-family:poppinsbold" >{{pageData.title}}</span><br>
        <span style="font-size:14px;font-family:poppinslight" >{{ formatDate(pageData.blogdate).slice(0,11) }}</span><br>
        <!-- <span style="font-size:14px;font-weight:light" >{{pageData.category.name}}</span> -->
      </v-flex> 
    </v-layout>
    <v-layout wrap pt-4 justify-center>
         <v-flex text-left xs12 sm8 px-2 pt-12 pt-md-4 py-4>
        <span id="pageContent" style="font-family:poppinsregular"  v-html="pageData.text"></span>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      pageContent: null,
      email: null,
      phone: null,
      pageData: [],
    };
  },
  beforeMount() {
    this.getData();
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/home/newblog/get",
        params: {
          id: this.$route.query.id,
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.appLoading = false;
            this.pageData = response.data.data;
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
     formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      dt = dt.toString();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime =
        day +
        " " +
        dt.slice(4, 7) +
        " " +
        year +
        " " +
        hours +
        ":" +
        minutes +
        " " +
        ampm;
      return strTime;
    },
  },
};
</script>
<style>
#pageContent p img {
  max-width: 80vw;
  max-height: 200vh;
}
</style>